import React from "react";
import { Colors } from "@utils";
import Modal from "react-modal";

import { Button } from "@components/atoms";

interface ModalProps extends Modal.Props {
  message: string;
  onOK: () => any;
}

const SimpleDialog = (props: ModalProps) => {
  const { message, onOK, ...rest } = props;

  return (
    <Modal {...rest}>
      <div className="flex flex-col items-center justify-center w-[318px] p-[20px]">
        <div className="flex items-center justify-center min-h-[110px]">
          <div
            className="text-center text-[16px]/[24px] font-[600] text-center whitespace-pre-wrap"
            style={{ color: Colors.totallyBlack }}
          >
            {message}
          </div>
        </div>
        <Button
          style={{ marginTop: 13, width: "100%" }}
          bgColor={Colors.primaryGreen}
          color={Colors.white}
          onClick={onOK}
        >
          확인
        </Button>
      </div>
    </Modal>
  );
};

export default SimpleDialog;
